import { AiOutlineAudit } from "react-icons/ai";
import { FaChalkboardTeacher, FaNotesMedical } from "react-icons/fa";
import { GoStop } from "react-icons/go";
import { HiUserGroup } from "react-icons/hi";
// import { TbReportMedical } from "react-icons/tb";

const lineChart = {
  seriesData: [
    {
      name: "Test ",
      type: "line",
      data: [3, 2, 1, 5, 4, 6],
    },
  ],
  Yaxis: {
    show: false,
    lineHeight: 0,
    height: 0,
    width: 0,
  },
  Xaxis: {
    show: false,
    type: "category",
    data: ["Project 1", "Project 2", "Project 3", "Project 4", "Project 5", "Project 6"],
    lineHeight: 0,
    width: 0,
  },
};

const OilvsGasSales = {
  xAxis: {
    name: "Project",
    nameLocation: "end",
    nameRotate: 90,
    nameTextStyle: {
      fontWeight: "bold",
    },
    type: "category",
    data: ["Project 1", "Project 2", "Project 3"],
  },
  yAxis: {
    name: "Oil Vs Gas Sales",
    nameLocation: "end",
    type: "value",
    min: 0, // minimum value to start
    minInterval: 1, // for integer axis value
    nameTextStyle: {
      fontWeight: "bold",
      padding: [0, 0, 0, 50],
    },
  },
  series: [
    {
      name: "Gas Sales",
      type: "bar",
      barGap: 0,
      color: "#e7404a",
      data: [1, 2, 3],
    },
    {
      name: "Oil Sales",
      type: "bar",
      barGap: 0,
      color: "#28b873",
      data: [1, 2, 3],
    },
  ],
};

const LaqAmountPaid = [
  {
    name: "LAQ Amount Paid",
    type: "pie",
    radius: "85%",
    center: ["50%", "50%"],
    data: [
      {
        value: 335,
        name: "Location 1",
      },
      {
        value: 310,
        name: "Location 2",
      },
      {
        value: 274,
        name: "Location 3",
      },
      {
        value: 235,
        name: "Location 4",
      },
      {
        value: 400,
        name: "Location 5",
      },
    ].sort(function (a, b) {
      return a.value - b.value;
    }),
    roseType: "radius",
    label: {
      normal: {
        textStyle: {
          color: "#333",
        },
      },
    },
    labelLine: {
      normal: {
        lineStyle: {
          color: "#333",
        },
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
    },
    itemStyle: {
      normal: {
        color: "rgb(102, 51, 153)",
        shadowBlur: 200,
        shadowColor: "rgba(0, 0, 0, 0.0)",
      },
    },

    animationType: "scale",
    animationEasing: "elasticOut",
    animationDelay: function (idx) {
      return Math.random() * 200;
    },
  },
];

const LaqAmountPending = [
  {
    name: "LAQ Amount Pending",
    type: "pie",
    radius: "85%",
    center: ["50%", "50%"],
    data: [
      {
        value: 335,
        name: "Location 1",
      },
      {
        value: 310,
        name: "Location 2",
      },
      {
        value: 274,
        name: "Location 3",
      },
      {
        value: 235,
        name: "Location 4",
      },
      {
        value: 400,
        name: "Location 5",
      },
    ].sort(function (a, b) {
      return a.value - b.value;
    }),
    roseType: "radius",
    label: {
      normal: {
        textStyle: {
          color: "#333",
        },
      },
    },
    labelLine: {
      normal: {
        lineStyle: {
          color: "#333",
        },
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
    },
    itemStyle: {
      normal: {
        color: "rgb(102, 51, 153)",
        shadowBlur: 200,
        shadowColor: "rgba(0, 0, 0, 0.0)",
      },
    },

    animationType: "scale",
    animationEasing: "elasticOut",
    animationDelay: function (idx) {
      return Math.random() * 200;
    },
  },
];

const ProductionWellCount = {
  xAxis: {
    name: "Time",
    type: "category",
    data: ["01-01-2021", "01-02-2021", "01-03-2021", "01-04-2021"],
    boundaryGap: false,
    axisLabel: {
      color: "#999",
    },
    axisLine: {
      color: "#999",
      lineStyle: {
        color: "#999999",
      },
    },
  },
  yAxis: {
    name: "Well Count",
    type: "value",
    min: 0, // minimum value to start
    minInterval: 1, // for integer axis value

    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  seriesData: [
    {
      name: "Alpha",
      data: [70, 65, 85, 75, 95, 86, 93],
      type: "line",
      smooth: true,
      symbolSize: 8,
      lineStyle: {
        color: "#ff5721",
        opacity: 1,
        width: 1.5,
      },
      itemStyle: {
        color: "#fff",
        borderColor: "#ff5721",
        borderWidth: 1.5,
      },
    },
    {
      name: "Beta",
      data: [80, 90, 75, 104, 75, 80, 70],
      type: "line",
      smooth: true,
      symbolSize: 8,
      lineStyle: {
        color: "#5f6cc1",
        opacity: 1,
        width: 1.5,
      },
      itemStyle: {
        color: "#fff",
        borderColor: "#5f6cc1",
        borderWidth: 1.5,
      },
    },
    {
      name: "Gama",
      data: [110, 95, 102, 90, 105, 95, 108],
      type: "line",
      smooth: true,
      symbolSize: 10,
      lineStyle: {
        color: "#4cae50",
        opacity: 1,
        width: 1.5,
      },
      itemStyle: {
        color: "#fff",
        borderColor: "#4cae50",
        borderWidth: 1.5,
      },
    },
  ],
};

const EORIORWellCount = {
  category: ["Project 1", "Project 2", "Project 3"],
  seriesData: [
    {
      color: "#5f6bc2",
      name: "EOR",
      type: "bar",
      barGap: 0,
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: [320, 332, 301],
    },
    {
      color: "#28b873",
      name: "IOR",
      type: "bar",
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: [220, 182, 191],
    },
  ],
};
const Top5SpendCategory = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    data: ["2011", "2012"],
  },
  xAxis: {
    show: false,
    type: "value",
    boundaryGap: [0, 0.01],
  },
  yAxis: {
    type: "category",
    axisLine: {
      show: false,
    },
    axisTick: false,
    data: ["Category 1", "Category 2", "Category 3", "Category 4", "Category 5"],
    label: {
      show: true,
    },
  },
  series: [
    {
      name: "value",
      type: "bar",
      data: [10, 20, 30, 40, 50],
      label: {
        show: true,
        position: "right",
        valueAnimation: true,
      },
    },
  ],
};

export const CompanyDashboardConstant = {
  lineChart,
  OilvsGasSales,

  // second chart Screen
  LaqAmountPaid,
  LaqAmountPending,
  ProductionWellCount,
  EORIORWellCount,
  Top5SpendCategory,
};

export const WigetListHO = [
  {
    name: "Incidents",
    key: "totalIncident",
    value: "",
    icon: GoStop,
    link: "/health-safety-and-environment/incident-management/view-incidents",
  },
  {
    name: "OHSE Reviews",
    key: "totalOhse",
    value: "",
    icon: HiUserGroup,
    link: "/health-safety-and-environment/audits-meetings/views",
  },
  {
    name: "Trainings",
    key: "totalTraining",
    value: "",
    icon: FaChalkboardTeacher,
    link: "/health-safety-and-environment/training-management/status",
  },
  {
    name: "VFLs",
    key: "totalVflConducted",
    value: "",
    icon: AiOutlineAudit,
    link: "/health-safety-and-environment/vfl/manage",
  },
  {
    name: "Health Exams",
    key: "totalMedicalExamination",
    value: "",
    icon: FaNotesMedical,
    link: "health-safety-and-environment/medical/view-medical-data",
  },
];

export const WigetListRO = [
  {
    name: "Incidents",
    key: "totalIncident",
    value: "",
    icon: GoStop,
    link: "/health-safety-and-environment/incident-management/view-incidents",
  },
  {
    name: "OHSE Reviews ",
    key: "totalOhse",
    value: "",
    icon: HiUserGroup,
    link: "/health-safety-and-environment/audits-meetings/views",
  },
  {
    name: "Trainings",
    key: "totalTraining",
    value: "",
    icon: FaChalkboardTeacher,
    link: "/health-safety-and-environment/training-management/status",
  },
  {
    name: "Health Exams",
    key: "totalMedicalExamination",
    value: "",
    icon: FaNotesMedical,
    link: "health-safety-and-environment/medical/view-medical-data",
  },
  {
    name: "VFL Completed",
    key: "totalVflConducted",
    value: "",
    icon: AiOutlineAudit,
    link: "/health-safety-and-environment/vfl/manage",
  },
];

export const WigetListMINE = [
  {
    name: "Incidents",
    key: "totalIncident",
    value: "",
    icon: GoStop,
    link: "/health-safety-and-environment/incident-management/view-incidents",
  },
  {
    name: "OHSE Reviews ",
    key: "totalOhse",
    value: "",
    icon: HiUserGroup,
    link: "/health-safety-and-environment/audits-meetings/views",
  },
  {
    name: "Trainings",
    key: "totalTraining",
    value: "",
    icon: FaChalkboardTeacher,
    link: "/health-safety-and-environment/training-management/status",
  },
  {
    name: "Health Exams",
    key: "totalMedicalExamination",
    value: "",
    icon: FaNotesMedical,
    link: "health-safety-and-environment/medical/view-medical-data",
  },
  {
    name: "VFLs",
    key: "totalVflConducted",
    value: "",
    icon: AiOutlineAudit,
    link: "/health-safety-and-environment/vfl/manage",
  },
];

export const chartDataHO = [
  {
    name: "Incidents - By Type - Last 12 Months",
    yAxisName: "Count",
    xAxisName: "Month",
    value: "last12MonthsIncidentTypeTrend",
    type: "multiLine",
    isMines: true,
  },
  {
    name: "Incidents - By Severity - Last 12 Months",
    yAxisName: "Count",
    xAxisName: "Month",
    value: "last12MonthsIncidentSeverityTrend",
    type: "multiLine",
    isMines: true,
  },
  {
    name: "LTI Count - Last 12 Months",
    yAxisName: "",
    xAxisName: "Month",
    value: "timeSinceLastLTI",
    type: "line",
    isMines: true,
  },
  {
    name: "Trainings - Last 12 Months",
    yAxisName: "",
    xAxisName: "",
    value: "trainingTrend",
    type: "multiLine",
    isMines: true,
  },
  {
    name: "Health Exams - Last 12 Months",
    yAxisName: "",
    xAxisName: "",
    value: "medicalExamTrend",
    type: "multiLine",
    isMines: true,
  },
  {
    name: "VFL Completed - Last 12 Months",
    yAxisName: "Count",
    xAxisName: "Month",
    value: "vflTrend",
    type: "line",
    isMines: true,
  },
  {
    name: "CAPA Status - Last 12 Months",
    yAxisName: "",
    xAxisName: "",
    value: "OutstandingCAPAsTrend",
    type: "multiLine",
    isMines: true,
  },
];
export const chartDataRO = [
  {
    name: "Incident - By Type",
    yAxisName: "",
    xAxisName: "",
    value: "incidentTypes",
    type: "stack",
  },
  {
    name: "VFL Completed",
    yAxisName: "",
    xAxisName: "",
    value: "vflCompletedMines",
    customeTool: true,
    type: "barWithLabel",
  },
  {
    name: "OHSE Reviews Completed",
    yAxisName: "",
    xAxisName: "",
    value: "numberOfMeetingsSiteWise",
    customeTool: true,
    type: "barWithLabel",
  },
  {
    name: "Health Exams Performance",
    yAxisName: "",
    xAxisName: "",
    value: "medicalExaminationsCompletedVsFit",
    customeTool: true,
    type: "barWithLabel",
  },
  {
    name: "Trainings Completed",
    yAxisName: "",
    xAxisName: "",
    value: "completedTrainingsRO",
    customeTool: true,
    type: "barWithLabel",
  },
  {
    name: "Outstadning CAPAs",
    yAxisName: "",
    xAxisName: "",
    value: "sitesWithOutstandingCAPAs",
    type: "barWithLabel",
    customeTool: true,
  },
];
export const chartDataMINE = [
  {
    title: "Incident Type wise",
    value: "incidentTypes",
  },
  {
    title: "VFL Areas",
    value: "vflCompletedMines",
    isScroll: true,
  },
  {
    title: "OHSE Reviews - By Type",
    yAxisName: "",
    xAxisName: "",
    value: "numberOfMeetingsTypeWise",
  },
  {
    title: "Trainings - By Type",
    yAxisName: "",
    xAxisName: "",
    value: "completedTrainingsMines",
  },
  {
    name: "Health Exam - Fit status",
    yAxisName: "%",
    xAxisName: "",
    value: "medicalExaminationsCompletedVsFit",
    type: "barWithLabel",
  },
  {
    title: "CAPA Status",
    yAxisName: "",
    xAxisName: "",
    value: "CAPAStatusCountBarChart",
  },
];
